import { useState, useCallback } from 'react';

export type TableDensity = 'normal' | 'compact';

const STORAGE_KEY = 'orders-table-density';

function readDensity(): TableDensity {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored === 'compact' || stored === 'normal') return stored;
  } catch {
    // localStorage unavailable (e.g. private browsing edge cases)
  }
  return 'normal';
}

export function useTableDensity() {
  const [density, setDensityState] = useState<TableDensity>(readDensity);

  const setDensity = useCallback((next: TableDensity) => {
    setDensityState(next);
    try {
      localStorage.setItem(STORAGE_KEY, next);
    } catch {
      // ignore
    }
  }, []);

  const toggleDensity = useCallback(() => {
    setDensity(density === 'compact' ? 'normal' : 'compact');
  }, [density, setDensity]);

  return { density, toggleDensity };
}
